import Link from "next/link";
import type { TownSummary } from "@/lib/construction/types";
import { formatCount } from "@/lib/construction/normalise";
import { townHref } from "@/lib/construction/places";

type TownListProps = {
  towns: (TownSummary & { distanceKm?: number })[];
  label: string;
  showDistance?: boolean;
};

/** Grid of town links with company counts. */
export function TownList({ towns, label, showDistance = false }: TownListProps) {
  if (!towns.length) return null;
  return (
    <ul aria-label={label} className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
      {towns.map((t) => (
        <li key={t.key}>
          <Link
            href={townHref(t.region, t.slug)}
            className="flex items-center justify-between gap-3 rounded-xl border border-ink/[0.08] bg-white px-4 py-3 text-sm transition-colors hover:border-ink/30"
          >
            <span className="min-w-0 truncate font-semibold text-ink">
              {t.id ? <span data-mdlfy-cms={`directory_towns:${t.id}:name`}>{t.name}</span> : t.name}
              {showDistance && typeof t.distanceKm === "number" ? (
                <span className="ml-1.5 font-normal text-ink-muted">· {Math.round(t.distanceKm)} km</span>
              ) : null}
            </span>
            <span className="shrink-0 text-ink-muted">{formatCount(t.count)}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
